import { Shield } from 'lucide-react';
import { cn, calculatePBNScore, trustLevelConfig } from '../lib/utils';

/**
 * DomainTrustBadge - Shield icon showing PBN/Real/Spam classification.
 *
 * Colors: green=Trusted, yellow=Caution, orange=Suspicious, grey=Unknown
 * Tooltip shows which signals triggered the classification.
 */
export default function DomainTrustBadge({
  da,
  traffic,
  referringDomains,
  referringIps,
  backlinksCount,
  spamScore,
  dfsSpamScore,
  size = 'sm',
  compact = false,
}) {
  // Check if we have enough data to classify
  const hasData = da != null || traffic != null || referringDomains != null;

  const { pbnScore, trustLevel, signals } = hasData
    ? calculatePBNScore({
        da: parseFloat(da) || 0,
        traffic: parseInt(traffic) || 0,
        referringDomains: parseInt(referringDomains) || 0,
        referringIps: parseInt(referringIps) || 0,
        backlinksCount: parseInt(backlinksCount) || 0,
        spamScore: parseFloat(spamScore) || 0,
        dfsSpamScore: dfsSpamScore != null ? parseFloat(dfsSpamScore) : null,
      })
    : { pbnScore: 0, trustLevel: 'unknown', signals: [] };

  const config = trustLevelConfig[trustLevel];
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';

  // Build tooltip text
  const tooltipParts = [];
  if (da != null) tooltipParts.push(`DA ${Math.round(da)}`);
  if (traffic) tooltipParts.push(`${Number(traffic).toLocaleString()} traffic`);
  if (referringDomains) tooltipParts.push(`${referringDomains} ref domains`);
  if (referringIps) tooltipParts.push(`${referringIps} IPs`);

  const tooltip = hasData
    ? `${config.label} (${pbnScore}/5 flags)\n${tooltipParts.join(' | ')}${signals.length ? '\n' + signals.join(', ') : ''}`
    : 'Insufficient data';

  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 px-1.5 py-0.5 rounded-md border text-xs font-medium cursor-default',
        config.bg,
        config.border,
        config.color,
      )}
      title={tooltip}
    >
      <Shield className={iconSize} />
      {!compact && <span className="hidden lg:inline">{config.label}</span>}
    </div>
  );
}
